export const APP_NAME = 'AgentAI'
export const IMG_HANDLER_URL = 'https://d2xkes67nhvb8h.cloudfront.net'

// TODO: find a way to remove hardcoded parent device
export const PARENT_DEVICE = 25100

export const CATEGORY_ICONS = {
  // Tutorial
  'Getting Started': 'play-triangle-outline',
  Camera: 'photo-camera-outline',
  'Camera - Basic': 'photo-camera-outline',
  'Camera - Advanced': 'photo-camera-outline',
  Calls: 'phone-auricular-outline',
  Voicemail: 'microphone',
  Messaging: 'chat-comment-oval-speech-bubble-with-text-lines',
  Contacts: 'book-outline',
  'Web Browser': 'planetary-grid-symbol',
  Personalization: 'pencil-big-outlined-vertical-tool-symbol',
  Security: 'lock-circular-padlock-outline-tool-symbol',
  Apps: 'four-rounded-squares-button',
  'Music Player': 'musical-note',
  'Maps & Navigation': 'big-map-placeholder-outlined-symbol-of-interface',
  Calendar: 'weekly-calendar-outline-event-interface-symbol',
  'Bluetooth® ': 'cellphone',
  Settings: 'gear-outlined-symbol',
  Memory: 'cube-of-notes-stack',
  // Faq
  Products: 'shopping-cart-outline-1',
  'Email & Documents': 'email-closed-outlined-back-envelope-interface-symbol',
  'General Information': 'checkmark-outline',
  Power: 'electrical-storm-weather-symbol',
  'Sound Settings': 'speaker-outline',
  'Mobile Hotspot': 'fork',
  'General Settings': 'wrench-outline',
  Features: 'favourites-star-outline-interface-symbol',
  'Display Settings': 'cellular-phone-outline',
  Phones: 'cellular-phone-outline',
  Bluetooth: 'cellphone'
}
